var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Navbar'),_c('DashBoard',{attrs:{"TIME":"7 NGÀY GẦN NHẤT"}}),_c('vue-headful',{attrs:{"title":"REPORT LAST WEEK"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }